var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 263.574c26.241-40.425 52.66-68.794 79.255-85.106C105.851 162.156 132.624 154 159.575 154c21.985 0 41.134 4.255 57.446 12.766 16.312 8.51 31.383 17.73 45.213 27.66 13.83 9.929 26.95 19.148 39.362 27.66 12.411 8.51 26.063 12.765 40.957 12.765 14.894 0 28.546-5.319 40.958-15.957 12.411-10.639 24.29-25.887 35.638-45.745L500 235.915c-26.241 40.426-52.66 68.794-79.255 85.106-26.596 16.312-53.369 24.468-80.32 24.468-21.985 0-41.134-4.255-57.446-12.766-16.312-8.51-31.383-17.73-45.213-27.66-13.83-9.928-26.95-19.148-39.362-27.659-12.411-8.51-26.064-12.766-40.957-12.766-14.185 0-27.66 5.32-40.426 15.958-12.766 10.638-24.822 25.886-36.17 45.744L0 263.574z","fillRule":"evenodd","fill":"currentColor"}));
}

Home.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = Home;

Home.default = Home;
